var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 10.4134V16.6667H23.8937C23.7337 16.6534 23.387 16.4534 23.307 16.3067L21.9203 13.6801C21.3737 12.6401 20.427 12.0534 19.4137 12.1067C18.4003 12.1601 17.5337 12.8401 17.0937 13.9467L15.2537 18.5601L14.987 17.8667C14.3337 16.1734 12.467 14.8934 10.627 14.8934L2.66699 14.9334V10.4134C2.66699 5.56008 5.56033 2.66675 10.4137 2.66675H21.587C26.4403 2.66675 29.3337 5.56008 29.3337 10.4134Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 21.5865V18.6665H23.8937C23.0003 18.6665 21.947 18.0265 21.5337 17.2398L20.147 14.6131C19.7737 13.9065 19.2403 13.9465 18.947 14.6798L15.8803 22.4265C15.547 23.2931 14.987 23.2931 14.6403 22.4265L13.1203 18.5865C12.7603 17.6531 11.6403 16.8931 10.6403 16.8931L2.66699 16.9331V21.5865C2.66699 26.3598 5.46699 29.2398 10.1737 29.3198C10.3203 29.3331 10.4803 29.3331 10.627 29.3331H21.2937C21.4937 29.3331 21.6937 29.3331 21.8803 29.3198C26.5603 29.2131 29.3337 26.3465 29.3337 21.5865Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66598 16.9333V21.3467C2.63931 20.92 2.62598 20.4667 2.62598 20V16.9333H2.66598Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagActive);
export default __webpack_public_path__ + "static/media/TagActive.e3dd1453b93bbcc7241129e0d428ca8a.svg";
export { ForwardRef as ReactComponent };